// #region imports

// --- Angular
import { Component, OnInit, Input, ViewChild, Renderer2, Output, EventEmitter, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

// --- HS Code
import { DemographicModel, SelectListItem } from '../../../models';

// #endregion

@Component({
  selector: 'hs-demographics-component',
  templateUrl: './demographics-component.component.html',
  styleUrls: ['./demographics-component.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DemographicsComponentComponent),
      multi: true
    }
  ]
})
export class DemographicsComponentComponent implements OnInit, ControlValueAccessor  {
  @Input() controlId: string;
  @Input() name: string;
  // @Input() demographic: DemographicModel;
  @Input() demographic: SelectListItem[];
  @Input() validationMessage: string;

  @Output() valueChange = new EventEmitter<string>();
  @Output() lostFocus = new EventEmitter();

  @ViewChild('ddlDemographicValue', { static: true }) ddlDemographicValue;

  selectedValue: string;

  onChange: (arg0: string) => void;
  onTouched: () => void;

  errorMessage: string;

  constructor(private renderer: Renderer2) {  }

  ngOnInit() {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    const select = this.ddlDemographicValue.nativeElement;
    this.renderer.setProperty(select, 'disabled', isDisabled);
  }

  writeValue(value: string): void {
    const selectedValue = this.demographic.find(v => v.value === value);
    if (selectedValue) {
      selectedValue.isSelected = true;
    }
    this.selectedValue = value;
  }

  onDemographicChange(demographicValueId: string): void {
    this.onChange(demographicValueId);
    this.valueChange.emit(demographicValueId);
  }

  onFocus(): void {
    this.onTouched();
  }

  onBlur(): void {
    this.lostFocus.emit(this);
  }
}
